import dayjs from 'dayjs';
import 'dayjs/locale/de';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';
import weekday from 'dayjs/plugin/weekday';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.locale('de');
dayjs.extend(localizedFormat);
dayjs.extend(localeData);

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Vienna');

dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(weekday);

dayjs.extend(customParseFormat);
